import { DirectiveOptions } from 'vue';

import { isInViewport } from '@/shared/filters/utils-filter';

const directive: DirectiveOptions = {
    bind(el, binding, node) {
        let IsInView = () => {
            if (isInViewport(el)) {
                el.classList.add(binding.value);
            }

            if (el.classList.contains(binding.value)) {
                document.removeEventListener('scroll', IsInView);
            }
        }
        
        setTimeout(() => {
            IsInView()
        }, 200);

        document.addEventListener('scroll', IsInView);
        
    }
};

export default directive;